{
  "favouriteAdded": "Favorite Added",
  "favouriteCleared": "Favorite Cleared",
  "favouriteEdited": "Favorite Edited",
  "unableToAddFavourite": "We were unable to add this favorite",
  "unableToClearFavourite": "We were unable to clear this favorite",
  "unableToEditFavourite": "We were unable to edit this favorite",
  "contactLink": {
    "contactLinkAuthorised": "Contact link authorized"
  }
}
